exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".money-input[data-v-135fcdbe]{max-width:inherit}.money-div[data-v-135fcdbe]{max-width:100px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-135fcdbe","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/loja/vue-components/CalcCategoria.vue
// module id = 291
// module chunks = 1